import { useMemo } from "react";

import { useTranslation } from 'react-i18next';
function getStrength(password) {
  let score = 0;
  if (!password) return { score: 0, label: "", color: "bg-zinc-800" };
  if (password.length >= 6) score++;
  if (password.length >= 10) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;

  if (score <= 1) return { score: 1, label: "Weak", color: "bg-red-500" };
  if (score <= 2) return { score: 2, label: "Fair", color: "bg-orange-500" };
  if (score <= 3) return { score: 3, label: "Good", color: "bg-yellow-500" };
  if (score <= 4) return { score: 4, label: "Strong", color: "bg-emerald-500" };
  return { score: 5, label: "Very Strong", color: "bg-emerald-400" };
}

export default function PasswordStrength({ password }) {
  const { t } = useTranslation();
  const { score, label, color } = useMemo(() => getStrength(password), [password]);
  if (!password) return null;

  return (
    <div className="mt-2">
      <div className="flex gap-1 mb-1">
        {[1, 2, 3, 4, 5].map((i) => (
          <div
            key={i}
            className={`h-1 flex-1 rounded-full transition-colors ${
              i <= score ? color : "bg-zinc-800"
            }`}
          />
        ))}
      </div>
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
        Password strength: <span className={score <= 1 ? "text-red-400" : score <= 2 ? "text-orange-400" : score <= 3 ? "text-yellow-400" : "text-emerald-400"}>{label}</span>
      </div>
    </div>
  );
}
